module.exports = __webpack_public_path__ + "static/media/selo.9f791e57.svg";